<template>
  <b-row align-h="center">
    <div cols="12" class="w-75">
      <FITModal :title="$t('crm.customer.create.header')" reference="customerConfirmationModal" ref="confirmation" @click="confirm">
        <div slot="body">
          {{ $t('crm.customer.create.confirmation') }}
        </div>
      </FITModal>
      <b-modal ref="leadList" size="lg" :hide-header="true" :hide-footer="true">
        <div class="text-center">
          <p class="lead ">{{ $t('crm.customer.doubleClick') }}</p>
          <LeadQuickSearch :callback="didSelectLead"></LeadQuickSearch>
          <p class="lead ">{{ $t('crm.customer.doubleClick') }}</p>
        </div>
      </b-modal>
      <b-alert show v-if="lead !== null" variant="info">
        <b-row>
          <b-col cols="6">
            <dl>
              <dt>{{ $t('crm.lead.create.name') }}</dt>
              <dd>{{ selectedLead.name }}</dd>
              <dt>{{ $t('crm.lead.create.dateOfContact') }}</dt>
              <dd>{{ selectedLead.dateOfContact | date }}</dd>
              <dt>{{ $t('crm.lead.create.activityLog') }}</dt>
              <dd>{{ selectedLead.activityLog }}</dd>
              <dt>{{ $t('crm.lead.create.remarks') }}</dt>
              <dd>{{ selectedLead.remarks }}</dd>
            </dl>
          </b-col>
          <b-col cols="6">
            <dl>
              <dt></dt>
              <dd></dd>
            </dl>
          </b-col>
        </b-row>
      </b-alert>
      <FITFormCard>
        <div slot="header">
          <b-row align-v="center">
            <b-col cols="6">
              <span class="h5"><i class="fa fa-id-card mr-2"></i>{{ $t('crm.customer.create.generalHeader') }}</span>
            </b-col>
            <b-col cols="6" class="text-right">
              <b-btn v-if="!isRemoteControlled && permissionLevel < 5.5" variant="link" size="sm" @click="openLeadModal" class="mr-2">
                <span><i class="fa fa-download mr-2"></i>{{ $t('crm.customer.importFromLead') }}</span>
              </b-btn>
              <span class="h5" @click="updateLocked" v-if="ID !== null && permissionLevel < 5.5">
                <i style="cursor: pointer" :class="{ 'fa' : true, 'fa-lock' : locked, 'fa-unlock' : !locked }"></i>
              </span>
            </b-col>
          </b-row>
        </div>
        <div slot="formBody">
          <b-row>
            <b-col cols="6">
              <FITSelect :label="$t('crm.customer.create.customerType')" :placeholder="$t('crm.customer.create.customerType')" :options="customerTypes" v-model="form.customerType" :width="columnWidth" :disabled="locked"></FITSelect>
            </b-col>
          </b-row>
          <!-- Individual Customer -->
          <template v-if="form.customerType == 'I'">
            <b-row>
              <b-col cols="6">
                <FITSelect field="title" :label="$t('crm.customer.create.title')" :placeholder="$t('crm.customer.create.title')" :options="titles" v-model="form.title" :width="columnWidth" :disabled="locked"></FITSelect>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <FITTextInput field="englishLastname" :label="$t('crm.customer.create.englishLastname')" :placeholder="
            $t('crm.customer.create.englishLastname')" v-model.trim="form.englishLastname" :width="columnWidth" :disabled="locked"></FITTextInput>
                <FITTextInput field="chineseFirstname" :label="$t('crm.customer.create.chineseFirstname')" :placeholder="$t('crm.customer.create.chineseFirstname')" v-model.trim="form.chineseFirstname" :width="columnWidth" :disabled="locked"></FITTextInput>
                <FITTextInput field="identityCardNo" :label="$t('crm.customer.create.identityCardNo')" :placeholder="$t('crm.customer.create.identityCardNo')" v-model.trim="form.identityCardNo" :width="columnWidth" :disabled="locked"></FITTextInput>
                <FITDatePicker field="dateOfBirth" :label="$t('crm.customer.create.dateOfBirth')" :placeholder="$t('crm.customer.create.dateOfBirth')" v-model="form.dateOfBirth" :width="columnWidth" :disabled="locked"></FITDatePicker>
                <FITSelect field="maritalStatus" :label="$t('crm.customer.create.maritalStatus')" :placeholder="$t('crm.customer.create.maritalStatus')" :options="maritalStatus" v-model="form.maritalStatus" :width="columnWidth" :disabled="locked"></FITSelect>
                <FITSelect field="nationality" :label="$t('crm.customer.create.nationality')" :placeholder="$t('crm.customer.create.nationality')" :options="nationality" v-model="form.nationality" :width="columnWidth" :disabled="locked"></FITSelect>
              </b-col>
              <b-col cols="6">
                <FITTextInput field="englishFirstname" :label="$t('crm.customer.create.englishFirstname')" :placeholder="
            $t('crm.customer.create.englishFirstname')" v-model.trim="form.englishFirstname" :width="columnWidth" :disabled="locked"></FITTextInput>
                <!--              <FITTextInput field="chineseLastname" :label="$t('crm.customer.create.chineseLastname')" :placeholder="$t('crm.customer.create.chineseLastname')" v-model="form.chineseLastname" :width="columnWidth" :disabled="locked"></FITTextInput> -->
                <div class="emptyRow"></div>
                <FITSelect field="idType" :label="$t('crm.customer.create.idType')" :placeholder="$t('crm.customer.create.idType')" :options="idTypes" v-model="form.idType" :width="columnWidth" :disabled="locked"></FITSelect>
                <FITSelect field="gender" :label="$t('crm.customer.create.gender')" :placeholder="$t('crm.customer.create.gender')" :options="genders" v-model="form.gender" :width="columnWidth" :disabled="locked"></FITSelect>
                <FITSelect field="contactType" :label="$t('crm.customer.create.contactType')" :placeholder="$t('crm.customer.create.contactType')" :options="contactTypes" v-model="form.contactType" :width="columnWidth" :disabled="locked"></FITSelect>
              </b-col>
              <b-col cols="12">
                <FITTextarea field="nationalityRemarks" :label="$t('crm.customer.create.nationalityRemarks')" :placeholder="$t('crm.customer.create.nationalityRemarks')" v-model="form.nationalityRemarks" :width="columnWidth+2" :disabled="locked"></FITTextarea>
              </b-col>
            </b-row>
          </template>
          <!-- Company Customer -->
          <template v-else>
            <b-row>
              <b-col cols="6">
                <FITTextInput field="englishFirstname" :label="$t('crm.customer.create.englishCompanyName')" :placeholder="
            $t('crm.customer.create.englishCompanyName')" v-model.trim="form.englishFirstname" :width="columnWidth" :disabled="locked"></FITTextInput>
                <FITTextInput field="brNo" :label="$t('crm.customer.create.brNo')" :placeholder="$t('crm.customer.create.brNo')" v-model.trim="form.identityCardNo" :width="columnWidth" :disabled="locked"></FITTextInput>
              </b-col>
              <b-col cols="6">
                <FITTextInput :label="$t('crm.customer.create.chineseCompanyName')" :placeholder="$t('crm.customer.create.chineseCompanyName')" v-model.trim="form.chineseFirstname" :width="columnWidth" :disabled="locked"></FITTextInput>
                <FITSelect field="contactType" :label="$t('crm.customer.create.contactType')" :placeholder="$t('crm.customer.create.contactType')" :options="contactTypes" v-model="form.contactType" :width="columnWidth" :disabled="locked"></FITSelect>
              </b-col>
            </b-row>
          </template>
        </div>
      </FITFormCard>
      <FITFormCard>
        <div slot="header">
          <b-row>
            <b-col cols="8">
              <p class="h5"><i class="fa fa-phone-square mr-2"></i>{{ $t('crm.customer.create.contactHeader') }}</p>
            </b-col>
            <b-col cols="4" class="text-right">
            </b-col>
          </b-row>
        </div>
        <div slot="formBody">
          <template v-if="form.customerType == 'I'">
            <b-row>
              <b-col cols="6">
                <FITTextInput field="telephoneMobile" :label="$t('crm.customer.create.telephoneMobile')" :placeholder="
            $t('crm.customer.create.telephoneMobile')" v-model="form.telephoneMobile" :width="columnWidth" :disabled="locked"></FITTextInput>
                <FITTextInput :label="$t('crm.customer.create.telephoneHome')" :placeholder="$t('crm.customer.create.telephoneHome')" v-model="form.telephoneHome" :width="columnWidth" :disabled="locked"></FITTextInput>
                <FITTextInput field="city" :label="$t('crm.customer.create.city')" :placeholder="$t('crm.customer.create.city')" v-model="form.city" :width="columnWidth" :disabled="locked"></FITTextInput>
              </b-col>
              <b-col cols="6">
                <FITTextInput field="telephoneOffice" :label="$t('crm.customer.create.telephoneOffice')" :placeholder="$t('crm.customer.create.telephoneOffice')" v-model="form.telephoneOffice" :width="columnWidth" :disabled="locked"></FITTextInput>
                <div class="emptyRow"></div>
                <FITSelect field="country" :label="$t('crm.customer.create.country')" :placeholder="$t('crm.customer.create.country')" :options="nationality" v-model="form.country" :width="columnWidth" :disabled="locked"></FITSelect>
                <!-- <FITTextInput field="fax" :label="$t('crm.customer.create.fax')" :placeholder="$t('crm.customer.create.fax')" v-model="form.fax" :width="columnWidth" :disabled="locked"></FITTextInput> -->
                <!-- <FITTextInput field="email" :label="$t('crm.customer.create.email')" :placeholder="$t('crm.customer.create.email')" v-model="form.email" :width="columnWidth" :disabled="locked"></FITTextInput> -->
              </b-col>
              <b-col cols="12" class="my-3">
                <span class="h5">
                  {{$t('crm.customer.create.residentialAddress')}}
                </span>
                <b-row class="pt-2 pb-3">
                  <b-col cols="12">
                    <FITTextarea field="englishResidentialAddress" :label="$t('crm.customer.create.englishResidentialAddress')" :placeholder="$t('crm.customer.create.englishResidentialAddress')" v-model="form.englishResidentialAddress" :width="11" :disabled="locked" alignV="top"></FITTextarea>
                  </b-col>
                  <!--              <b-col cols="6">
                    <FITTextarea field="chineseResidentialAddress" :label="$t('crm.customer.create.chineseResidentialAddress')" :placeholder="$t('crm.customer.create.chineseResidentialAddress')" v-model="form.chineseResidentialAddress" :width="10" :disabled="locked" alignV="top"></FITTextarea>
                  </b-col> -->
                </b-row>
                <b-row>
                  <b-col cols="auto">
                    <span class="h5 mr-5">{{$t('crm.customer.create.correspondenceAddress')}}</span>
                    <span class="text-danger">{{$t('crm.customer.create.correspondenceAddressLeaveBlank')}}</span>
                  </b-col>
                </b-row>
                <b-row class="pt-2 pb-3">
                  <b-col cols="12">
                    <FITTextarea field="englishCorrespondenceAddress" :label="$t('crm.customer.create.englishCorrespondenceAddress')" :placeholder="$t('crm.customer.create.englishCorrespondenceAddress')" v-model="form.englishCorrespondenceAddress" :width="11" :disabled="locked" alignV="top"></FITTextarea>
                  </b-col>
                  <!-- <b-col cols="6">
                    <FITTextarea field="chineseCorrespondenceAddress" :label="$t('crm.customer.create.chineseCorrespondenceAddress')" :placeholder="$t('crm.customer.create.chineseCorrespondenceAddress')" v-model="form.chineseCorrespondenceAddress" :width="10" :disabled="locked" alignV="top"></FITTextarea>
                  </b-col> -->
                </b-row>
                <!-- <span class="h5">
                  {{$t('crm.customer.create.companyAddress')}}
                </span>
                <b-row class="pt-2 pb-3">
                  <b-col cols="6">
                    <FITTextarea field="englishCompanyAddress" :label="$t('crm.customer.create.englishCompanyAddress')" :placeholder="$t('crm.customer.create.englishCompanyAddress')" v-model="form.englishCompanyAddress" :width="10" :disabled="locked" alignV="top"></FITTextarea>
                  </b-col>
                  <b-col cols="6">
                    <FITTextarea field="chineseCompanyAddress" :label="$t('crm.customer.create.chineseCompanyAddress')" :placeholder="$t('crm.customer.create.chineseCompanyAddress')" v-model="form.chineseCompanyAddress" :width="10" :disabled="locked" alignV="top"></FITTextarea>
                  </b-col>
                </b-row> -->
              </b-col>
            </b-row>
          </template>
          <template v-else>
            <b-row>
              <b-col cols="6">
                <FITTextInput field="telephoneOffice" :label="$t('crm.customer.create.telephoneOffice')" :placeholder="$t('crm.customer.create.telephoneOffice')" v-model="form.telephoneOffice" :width="columnWidth" :disabled="locked"></FITTextInput>
                <FITTextInput field="email" :label="$t('crm.customer.create.email')" :placeholder="
            $t('crm.customer.create.email')" v-model="form.email" :width="columnWidth" :disabled="locked"></FITTextInput>
                <FITTextInput field="city" :label="$t('crm.customer.create.city')" :placeholder="$t('crm.customer.create.city')" v-model="form.city" :width="columnWidth" :disabled="locked"></FITTextInput>
              </b-col>
              <b-col cols="6">
                <FITTextInput field="fax" :label="$t('crm.customer.create.fax')" :placeholder="$t('crm.customer.create.fax')" v-model="form.fax" :width="columnWidth" :disabled="locked"></FITTextInput>
                <div class="emptyRow"></div>
                <FITSelect field="country" :label="$t('crm.customer.create.country')" :placeholder="$t('crm.customer.create.country')" :options="nationality" v-model="form.country" :width="columnWidth" :disabled="locked"></FITSelect>
              </b-col>
              <b-col cols="12">
                <span class="h5">
                  {{$t('crm.customer.create.companyAddress')}}
                </span>
                <FITTextarea field="englishCompanyAddress" :label="$t('crm.customer.create.englishCompanyAddress')" :placeholder="$t('crm.customer.create.englishCompanyAddress')" v-model="form.englishCompanyAddress" :width="11" :disabled="locked"></FITTextarea>
                <!-- <FITTextarea field="chineseCompanyAddress" :label="$t('crm.customer.create.chineseCompanyAddress')" :placeholder="$t('crm.customer.create.chineseCompanyAddress')" v-model="form.chineseCompanyAddress" :width="10" :disabled="locked"></FITTextarea> -->
                <b-row>
                  <b-col cols="4">
                    <span class="h5">
                    {{$t('crm.customer.create.correspondenceAddress')}}
                  </span>
                  </b-col>
                  <b-col cols="12" class="text-center">
                    <span class="text-danger">{{$t('crm.customer.create.companyCorrespondenceAddressLeaveBlank')}}</span>
                  </b-col>
                </b-row>
                <FITTextarea field="englishCorrespondenceAddress" :label="$t('crm.customer.create.englishCorrespondenceAddress')" :placeholder="$t('crm.customer.create.englishCorrespondenceAddress')" v-model="form.englishCorrespondenceAddress" :width="11" :disabled="locked"></FITTextarea>
                <!--  <FITTextarea field="chineseCorrespondenceAddress" :label="$t('crm.customer.create.chineseCorrespondenceAddress')" :placeholder="$t('crm.customer.create.chineseCorrespondenceAddress')" v-model="form.chineseCorrespondenceAddress" :width="10" :disabled="locked"></FITTextarea> -->
              </b-col>
            </b-row>
          </template>
        </div>
      </FITFormCard>
      <FITFormCard>
        <div slot="header">
          <p class="h5"><i class="fa fa-user-circle mr-2"></i>{{ $t('crm.customer.create.customerHeader') }}</p>
        </div>
        <div slot="formBody">
          <template v-if="form.customerType == 'I'">
            <b-row>
              <b-col cols="6">
                <FITTextInput field="customerCode" :label="$t('crm.customer.create.customerCode')" :placeholder="$t('crm.customer.create.customerCode')" v-model.trim="form.customerCode" :width="columnWidth" :disabled="locked"></FITTextInput>
                <!-- <FITSelect field="smoker" :label="$t('crm.customer.create.smoker')" :placeholder="$t('crm.customer.create.smoker')" :options="somkers" v-model="form.smoker" :width="columnWidth" :disabled="locked"></FITSelect> -->
                <FITSelect field="education" :label="$t('crm.customer.create.education')" :options="educations" :placeholder="$t('crm.customer.create.education')" v-model="form.education" :width="columnWidth" :disabled="locked"></FITSelect>
                <FITSelect field="status" :label="$t('crm.customer.create.status')" :options="status" :placeholder="$t('crm.customer.create.status')" v-model="form.status" :width="columnWidth" :disabled="locked"></FITSelect>
                <FITSelect field="riskLevel" :label="$t('crm.customer.create.riskLevel')" :options="riskLevel" :placeholder="$t('crm.customer.create.riskLevel')" v-model="form.riskLevel" :width="columnWidth" :disabled="locked"></FITSelect>
              </b-col>
              <b-col cols="6">
                <FITTextInput field="occupation" :label="$t('crm.customer.create.occupation')" :placeholder="$t('crm.customer.create.occupation')" v-model.trim="form.occupation" :width="columnWidth" :disabled="locked"></FITTextInput>
                <FITTextInput field="nameOfEmployer" :label="$t('crm.customer.create.nameOfEmployer')" :placeholder="$t('crm.customer.create.nameOfEmployer')" v-model="form.nameOfEmployer" :width="columnWidth" :disabled="locked"></FITTextInput>
                <b-row class="my-3" align-v="center">
                  <b-col cols="3">
                    <span>{{$t('crm.customer.create.vulnerable')}}</span>
                  </b-col>
                  <b-col cols="9">
                    <FITCheckbox v-model="form.vulnerable" trueString="Y" falseString="N" :width="columnWidth" :disabled="locked"></FITCheckbox>
                  </b-col>
                </b-row>
                <!-- <FITTextInput field="lengthOfServices" :label="$t('crm.customer.create.lengthOfServices')" :placeholder="$t('crm.customer.create.lengthOfServices')" v-model="form.lengthOfServices" :width="columnWidth" :disabled="locked"></FITTextInput> -->
              </b-col>
            </b-row>
          </template>
          <template v-else>
            <b-row>
              <b-col cols="6">
                <FITTextInput field="customerCode" :label="$t('crm.customer.create.customerCode')" :placeholder="$t('crm.customer.create.customerCode')" v-model.trim="form.customerCode" :width="columnWidth" :disabled="locked"></FITTextInput>
                <FITSelect field="riskLevel" :label="$t('crm.customer.create.riskLevel')" :options="riskLevel" :placeholder="$t('crm.customer.create.riskLevel')" v-model="form.riskLevel" :width="columnWidth" :disabled="locked"></FITSelect>
              </b-col>
              <b-col cols="6">
                <FITSelect field="status" :label="$t('crm.customer.create.status')" :options="status" :placeholder="$t('crm.customer.create.status')" v-model="form.status" :width="columnWidth" :disabled="locked"></FITSelect>
                <b-row class="my-3" align-v="center">
                  <b-col cols="3">
                    <span>{{$t('crm.customer.create.vulnerable')}}</span>
                  </b-col>
                  <b-col cols="9">
                    <FITCheckbox v-model="form.vulnerable" trueString="Y" falseString="N" :width="columnWidth" :disabled="locked"></FITCheckbox>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </template>
        </div>
      </FITFormCard>
      <FITFormCard>
        <div slot="header">
          <b-row>
            <b-col cols="8">
              <p class="h5"><i class="fa fa-id-card mr-2"></i>{{ $t('crm.customer.create.personalHeader') }}</p>
            </b-col>
          </b-row>
        </div>
        <div slot="formBody">
          <b-row>
            <b-col cols="6">
              <FITTextInput field="email" :label="$t('crm.customer.create.userEmail')" :placeholder="
            $t('crm.customer.create.userEmail')" v-model="form.userEmail" :width="columnWidth" :disabled="locked"></FITTextInput>
              <FITSelect field="marketingOptOut" :label="$t('crm.customer.create.marketingOptOut')" :placeholder="$t('crm.customer.create.marketingOptOut')" :options="somkers" v-model="form.marketingOptOut" :width="columnWidth" :disabled="locked"></FITSelect>
            </b-col>
            <b-col cols="6">
              <FITSelect field="language" :label="$t('crm.customer.create.language')" :placeholder="$t('crm.customer.create.language')" :options="languages" v-model="form.language" :width="columnWidth" :disabled="locked"></FITSelect>
            </b-col>
          </b-row>
        </div>
      </FITFormCard>
      <div class="text-right w-100">
        <FITButton class="min-width-button" size="md" :variant="(ID !== null) ? 'warning' : 'primary'" text="Submit" @click="validationCheck" :disabled="locked" v-if="!isRemoteControlled && permissionLevel < 5.5"></FITButton>
      </div>
    </div>
  </b-row>
</template>
<script>
import {
  FITTextInput,
  FITAutoSearch,
  FITSelect,
  FITDatePicker,
  FITTextarea,
  FITButton,
  FITFormCard,
  FITModal,
  FITValidationBus,
  FITCheckbox
} from '@/components';

import { LeadQuickSearch } from '../Lead'
import { mapState, mapGetters } from 'vuex'
import Vue from 'vue';
import moment from 'moment';

export default {
  name: 'CustomerCreate',
  components: {
    FITTextInput,
    FITAutoSearch,
    FITSelect,
    FITDatePicker,
    FITTextarea,
    FITButton,
    FITFormCard,
    FITModal,
    FITCheckbox,
    LeadQuickSearch,
  },

  props: {
    ID: {
      type: Number,
      default: null
    },

    lead: {
      type: Object,
      default: null
    },

    isParentLocked: {
      type: Boolean,
      default: false
    },

    isRemoteControlled: {
      type: Boolean,
      default: false
    },

    initialData: {
      type: Object,
      default: () => {
        return {
          customerType: 'I',
          customerCode: '',
          englishFirstname: '',
          englishLastname: '',
          chineseFirstname: '',
          chineseLastname: '',
          smoker: 'N',
          identityCardNo: '',
          dateOfBirth: '',
          maritalStatus: 'S',
          nationality: '',
          idType: 'HKID',
          education: 'P',
          contactType: 'R',
          occupation: '',
          nameOfEmployer: '',
          lengthOfServices: '',
          gender: 'F',
          telephoneMobile: '',
          telephoneHome: '',
          telephoneOffice: '',
          city: '',
          country: '',
          status: 'A',
          vulnerable: 'N',
          riskLevel: 'L',
          fax: '',
          email: '',
          chineseResidentialAddress: '',
          englishResidentialAddress: '',
          chineseCorrespondenceAddress: '',
          englishCorrespondenceAddress: '',
          chineseCompanyAddress: '',
          englishCompanyAddress: '',
          marketingOptOut: 'N',
          userEmail: '',
          language: 'english',
          title: 'MS'
        }
      }
    }
  },

  created() {
    // Get Validation Rule
    let validationType = 'create'
    if (this.ID) {
      validationType = 'edit';
    }
    this.$store.commit('Validation/validationReset');
    this.$store.dispatch('Validation/getValidationRule', `/crm/customer/${validationType}`);
    this.$store.commit('Validation/setAlertMsg', { alertMsg: this.$t("validation.alertMsg.error") });
    this.$store.dispatch('getAllSelections', 'customer')
      .then((json) => {
        this.$store.commit({ type: 'Crm/setSelections', selection: json.data });
        if (this.lead) {
          this.didSelectLead(this.lead);
        }

        if (this.ID) {
          this.$store.dispatch('Crm/getCustomerList', {
            ID: this.ID
          }).then((json) => {
            if (json.data.list.length > 0) {
              Vue.set(this, 'form', json.data.list[0]);
              Vue.set(this, 'locked', true);
            }
          })
        }
      })
      .catch((err) => {
        console.error(err);
      })
  },
  computed: {
    permissionLevel() {
      return this.$store.state.permissionLevel;
    },
    ...mapGetters('Crm', [
      'getTranslated'
    ]),
    ...mapState({
      'vuexFinalResult': state => state.Validation.validationFinalResult,
    }),
    contactTypes() {
      return this.getTranslated(this.$i18n.locale, 'contactType');
    },

    maritalStatus() {
      return this.getTranslated(this.$i18n.locale, 'maritalStatus');
    },
    status() {
      return this.getTranslated(this.$i18n.locale, 'status');
    },
    riskLevel() {
      return this.getTranslated(this.$i18n.locale, 'riskLevel');
    },
    nationality() {
      return this.getTranslated(this.$i18n.locale, 'nationality');
    },

    educations() {
      return this.getTranslated(this.$i18n.locale, 'education');
    },

    idTypes() {
      return this.getTranslated(this.$i18n.locale, 'idType');
    },

    customerTypes() {
      return this.getTranslated(this.$i18n.locale, 'customerType');
    },

    titles() {
      return this.getTranslated(this.$i18n.locale, 'title');
    }
  },

  watch: {
    'form.customerType': function(newData, oldData) {
      this.$store.commit('Validation/validationReset');
      FITValidationBus.$emit('reset', true);
    },
    vuexFinalResult(newData, oldData) {
      let result = newData;
      // console.log("Final Result: "+newData);
      if (result) {
        this.openConfirmnModal();
        this.$store.commit('Validation/validationReset');
        // FITValidationBus.$emit('reset',true);

      }
    },
    form: {
      deep: true,
      handler(val) {
        this.$emit('input', val);
      }
    },
    initialData: {
      deep: true,
      handler(val) {
        Vue.set(this, 'form', JSON.parse(JSON.stringify(val)))
      }
    },

    isParentLocked(val) {
      Vue.set(this, 'locked', val)
    }
  },

  methods: {
    updateLocked() {
      Vue.set(this, 'locked', !this.locked);
    },
    validationCheck() {
      this.$store.dispatch('Validation/validationCheckBeforeSubmit');
      return;
    },

    didSelectLead(lead) {
      Vue.set(this.form, 'leadID', lead.ID);
      Vue.set(this.form, 'englishFirstname', lead.name);
      Vue.set(this.form, 'identityCardNo', lead.identityCardNo);
      Vue.set(this.form, 'telephoneMobile', lead.phoneNumber);
      Vue.set(this.form, 'gender', lead.gender);

      Vue.set(this, 'selectedLead', lead);
      this.$refs.leadList.hide();
    },

    openConfirmnModal() {
      this.$refs.confirmation.openModal();
    },

    openLeadModal() {
      this.$refs.leadList.show();
    },

    confirm(confirmed) {
      if (confirmed) {
        this.createCustomer();
      }
    },

    createCustomer() {
      if (this.form.customerType == 'C') {
        Vue.set(this.form, 'idType', 'BR');
        Vue.set(this.form, 'gender', 'N');
      }

      Vue.set(this.form, 'email', this.form.userEmail);

      if (this.form.ID) {
        this.$store.dispatch('Crm/editCustomer', this.form)
          .then((json) => {
            this.$router.replace({
              name: 'List Customer',
              params: { createSuccess: true }
            })
          })
          .catch((err) => {
            console.error(err);
          })
        return;
      }

      this.$store.dispatch('Crm/createCustomer', this.form)
        .then((json) => {
          this.$router.replace({
            name: 'List Customer',
            params: { createSuccess: true }
          })
        })
        .catch((err) => {
          console.error(err);
        })
    }
  },

  data() {
    return {
      locked: false,
      selectedLead: this.lead,
      columnWidth: 9,
      genders: [{
        text: 'Male',
        value: 'M'
      }, {
        text: 'Female',
        value: 'F'
      }],

      somkers: [{
        text: 'Yes',
        value: 'Y'
      }, {
        text: 'No',
        value: 'N'
      }],


      languages: [{
        text: 'English',
        value: 'english'
      }, {
        text: '繁體中文',
        value: 'zh_hk'
      }, {
        text: '简体中文',
        value: 'zh_cn'
      }],

      form: this.initialData
    }
  }
}

</script>
<style>
.min-width-button {
  min-width: 80px;
}

.emptyRow {
  margin-top: 68px !important;
}

</style>



// WEBPACK FOOTER //
// src/Crm/components/Customer/CustomerCreate.vue